

import {
  LogIn, User, CreditCard, Bell, Wind, Droplets, Users, Bot,
  Calendar, Check, X, Clock, Syringe, Pill, Stethoscope,
  Trash2, Sparkles, Shirt, Wine, Filter, Sun, Snowflake,
  BookOpen, ShoppingBag, Activity, Gift, Heart, Apple,
  UtensilsCrossed, LineChart, FileText, Hospital, Plane,
  FlaskConical, Store, Salad, TestTube, Wind as Breath,
  Zap, TrendingUp
} from 'lucide-react';
import styles from './Home.module.css';
import { Link } from 'react-router-dom';

const features = [
/*
  {
    icon: CreditCard,
    title: 'Abonnements-styring',
    description: 'Fleksibel abonnementsstyring med forskellige prisplaner',
  },
  {
    icon: CreditCard,
    title: 'Betaling – Stripe inkl. Mobile Pay',
    description: 'Sikker betaling gennem Stripe med support for Mobile Pay',
  },
  {
    icon: Bell,
    title: 'Acceptere Notifikationer',
    description: 'Modtag vigtige påmindelser og alarmer om din sundhed',
  },
*/ 
  {
    icon: Wind,
    title: 'Pollentracker med API',
    description: 'Real-time pollendata fra Weather Company API med alarmer/notifikationer ved høje tal',
  },
  {
    icon: Droplets,
    title: 'Luftfugtighed Monitoring',
    description: 'Overvågning af luftfugtighed med Weather Data API og alarmer ved høje/lave tal',
  },
  {
    icon: Users,
    title: 'Community',
    description: 'Facebook-lignende gruppe hvor medlemmer kan stille spørgsmål og dele erfaringer. Med organisering efter emner og søgefunktion',
  },
  /*
  {
    icon: Bot,
    title: 'Chat-bot med AI',
    description: 'Spørg AI i stedet for at vente på svar fra Facebook gruppe',
  },
  */
  {
    icon: Calendar,
    title: 'Kalenderstyring med Notifikationer',
    description: 'Opret og administrer opgaver med gentagelser (dag, uge, måned, år). Pop-up/notifikationer med mulighed for at ignorere, udsætte eller markere som færdig',
  },
  {
    icon: BookOpen,
    title: 'Videncenter',
    description: 'Artikler og blogs opdelt i emner for at lære mere om astma og allergi',
  },
  /*
  {
    icon: ShoppingBag,
    title: 'Rabatter',
    description: 'Eksklusive rabatter til Astma Allergi Shoppen og andre partnere',
  },
  */
  {
    icon: Activity,
    title: 'Inhalator Tracker',
    description: 'Spor hvor mange pust du har taget og hvor mange der er tilbage. Modtag påmindelse når det er tid til at købe ny',
  },
  /*
  {
    icon: Gift,
    title: 'Belønning til Små Børn',
    description: 'Motivationssystem for at hjælpe børn med at tage deres medicin',
  },
  {
    icon: Apple,
    title: 'Integration til Apple HealthKit',
    description: 'Synkroniser dine sundhedsdata med Apple Health',
  },
  */
  {
    icon: UtensilsCrossed,
    title: 'Maddagbog – Symptomtracker',
    description: 'Kalender hvor du indtaster alt hvad du indtager og dine symptomer. AI finder mønstre i hvad du reagerer på',
  },
  /*
  {
    icon: Syringe,
    title: 'Vaccinations-overblik',
    description: 'Skema pr. vaccination (græs, birk, husstøvmider, osv.) med dato, dosis og næste planlagt vaccination',
  },
  */
  {
    icon: FileText,
    title: 'Sygdomsdagbog',
    description: 'Registrer lægeaftaler, hospitalsindlæggelser og symptomer. Vis kronologisk forløb efter dato',
  },
  /*
  {
    icon: Stethoscope,
    title: 'Tilkobling af Fagpersonale',
    description: 'Kontakt direkte med læger og sundhedsprofessionelle',
  },
  {
    icon: Plane,
    title: 'Rejsehjælp',
    description: 'Oversættelser, nærmeste hospitaler og rejsetips for allergikere',
  },
  {
    icon: FlaskConical,
    title: 'Integration til Kemiluppen (TÆNK)',
    description: 'Få information om kemikalier i produkter',
  },
  {
    icon: Heart,
    title: '14 Dages Allergikur',
    description: 'Tilmeld dig et 14-dages kursus med plan og daglige notifikationer',
  },
  {
    icon: LineChart,
    title: 'Integration til Indeklima Målere',
    description: 'Forbind dine indeklima målere for komplet overblik',
  },
  {
    icon: Store,
    title: 'E-handel',
    description: 'Salg af produkter med integration til www.astmaallergishoppen.dk',
  },
  {
    icon: Salad,
    title: 'Allergivenlige Opskrifter',
    description: 'Opskrifter med sortering udfra hvad du ikke kan tåle (ex. uden æg og nødder)',
  },
  {
    icon: TestTube,
    title: 'Overblik over Allergiprøver',
    description: 'Blodprøver, priktest osv. Evt. indlæse fra sundhed.dk',
  },
  {
    icon: Breath,
    title: 'Åndedrætsøvelser',
    description: 'Guidede åndedrætsøvelser til at forbedre dit velvære',
  },
  {
    icon: Zap,
    title: 'AI Kombineret Triggeranalyse',
    description: 'AI analyserer kost, pollen, luftfugtighed osv. og giver helbredsscore',
  }
  */
];

export default function Features() {
  return (
    <div>
      <section className={styles.features}>
        <div className="container">
          <h1 className={styles.sectionTitle}>Se Funktioner</h1>
          <p className={styles.sectionLead}>Udforsk alle funktionerne i Astma-Allergi Hjælp appen</p>
          <div className={styles.cards}>
            {features.map((feature, idx) => {
              const Icon = feature.icon;
              return (
                <article className={styles.card} key={idx}>
                  <div className={styles.cardText}>
                    <h3>{feature.title}</h3>
                    <p>{feature.description}</p>
                  </div>
                  <div className={styles.cardIcon}><Icon size={22} /></div>
                </article>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}
